/**
 * Qui lit la carte Assiduité d'un dossier : les écrans de la garde de
 * `GET /api/emargement/assiduite/:id` — le pôle administratif depuis le dossier,
 * le pôle pédagogique et le formateur depuis « Apprenants ». L'apprenant relit
 * la sienne dans « Mon émargement », pas dans son dossier.
 */
const ECRANS_ASSIDUITE = ['adm-dossier', 'emargement', 'ped-absences'] as const;

export function peutLireAssiduiteDuDossier(peutAcceder: (ecran: string) => boolean, espaceCandidat: boolean): boolean {
  return !espaceCandidat && ECRANS_ASSIDUITE.some((ecran) => peutAcceder(ecran));
}
